<template>
  <div class="bank-details">
    <div class="details" v-html="labels['bankDetails']"></div>
    <div class="terms" v-html="labels['confirm'](terms)"></div>
    <button class="button button-outline donate" @click="showMainForm">
      {{ labels['showMainForm'] }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  computed: mapState({
    terms: state => state.terms,
    lang: state => state.language,
    labels: state => LABELS[state.language]
  }),
  methods: {
    showMainForm () {
      this.$store.dispatch('showStep', 'form')
      const app = this.$root.$refs['oi-donate']
      app.finishTransaction(true)
    }
  }
}
</script>

<style scoped>
  .oi-donation-form .bank-details {
    font-size: small;
    border-bottom: 1px solid #aaa;
    padding-bottom: 10px;
    user-select: text;
  }
  .oi-donation-form .bank-details .details {
    margin-bottom: 20px;
  }
  .oi-donation-form .terms {
    margin-bottom: 20px;
  }
</style>
